module.exports = __webpack_public_path__ + "static/media/tui.67b5276a.svg";